import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { TableColumn } from '../../../../core/models/table-column';
import { MaterialListItemModel } from '../../../../core/models/material/material-list-item.model';
import { MaterialColumnsEnum } from '../../../../core/state-mangement/entities/material-items/material-columns.enum';
import { MaterialModel } from '../../../../core/models/material/material-model';

@Component({
  selector: 'app-material-list-item',
  templateUrl: './material-list-item.component.html',
  styleUrls: ['./material-list-item.component.scss'],
})
export class MaterialListItemComponent implements OnInit {
  @Input() materialList$: Observable<MaterialModel[]>;
  @Input() tableColumns$: Observable<TableColumn[]>;
  @Input() selectedIndex$: Observable<number>;

  @Output() onClickEvent = new EventEmitter<number>();

  columns = MaterialColumnsEnum;

  constructor() {}

  ngOnInit() {}

  onClick(index: number) {
    this.onClickEvent.emit(index);
  }
}
